import _isEmpty from 'lodash/isEmpty';
import { actionChannel, call, put, select,take } from 'redux-saga/effects';

import { jobService } from 'services';

import { ACTION_TYPES } from '../jobs';
import * as selectors from '../selectors';

function* watchPaidJobs() {
  // 1. Create a channel
  const paidJobChannel = yield actionChannel(ACTION_TYPES.PAID_JOBS_LOADING);
  while (true) {
    // 2. take from the channel
    const { payload } = yield take(paidJobChannel);
    // 3. Call to paid jobs API
    yield call(handlePaidJobRequest, payload);
  }
}

function* handlePaidJobRequest(payload = {}) {
  try {
    const newPayload = { ...payload };
    const jobs = yield select(selectors.jobs);
    const dismissedListingHashes = newPayload.loadMore || newPayload.filtersChanged
      ? [...(jobs.dismissedJobs || []), ...(jobs[newPayload.type]?.dismissedListingHashes || [])]
      : [
          ...(jobs.dismissedJobs || []),
          ...(jobs.receivedPaidListingHashes || []),
          ...(jobs[newPayload.type]?.dismissedListingHashes || []),
        ];
    newPayload.filterDetail = {
      ...newPayload.filterDetail,
      dismissedListingHashes: !_isEmpty(newPayload.filterDetail.dismissedListingHashes)
        ? newPayload.filterDetail.dismissedListingHashes
        : dismissedListingHashes,
    };
    const result = yield call(jobService.getPaidJobs, newPayload.filterDetail);
    yield put({
      type: newPayload.loadMore ? ACTION_TYPES.FETCH_MORE : ACTION_TYPES.FETCHED,
      payload: {
        type: newPayload.type,
        isPaid: true,
        result: {
          ...result,
          fetched: true,
          hideOnEmpty: true,
        },
      },
    });
  } catch {
    yield put({
      type: ACTION_TYPES.ERROR_FETCH,
      payload: {
        type: payload.type,
        hideOnEmpty: true,
      },
    });
  }
}

export default watchPaidJobs;
